<!-- 停售数据操作 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <el-drawer :close-on-press-escape="true" :visible.sync="dataActionBox.showStatus" :with-header="false"
         append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                  :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <div>
                              <el-button type="primary" @click="extendsClick"
                                 v-if="dataActionBox.actionType != 2">提取</el-button>
                           </div>
                           <el-form class="baseForm" id="mainInfo" :model="sendDataInfo" ref="sendDataInfo" size="mini"
                              :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2" ref="baseForm">
                                 <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []"
                                    v-if="formOneValue.isShow == 1">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <template>
                                       <!-- 系统字段 -->
                                       <div v-if="formOneValue.isReserved == 0">
                                          <el-input v-if="formOneValue.fieldType == 'search'"
                                             :disabled="formOneValue.isChange == 0" clearable
                                             v-model.trim="sendDataInfo[formOneValue.entityField]"
                                             @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.setField, formOneValue.entityField)">
                                             <el-button
                                                @click="openSearch(formOneValue.searchId, formOneValue.setField, formOneValue.entityField)"
                                                slot="append" icon="el-icon-search"></el-button>
                                          </el-input>
                                          <el-date-picker v-else-if="formOneValue.fieldType == 'date'"
                                             :disabled="formOneValue.isChange == 0"
                                             v-model="sendDataInfo[formOneValue.entityField]" type="date"
                                             placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                                          </el-date-picker>
                                          <el-select
                                             v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.entityField == 'stReason'"
                                             :disabled="formOneValue.isChange == 0"
                                             v-model="sendDataInfo[formOneValue.entityField]" multiple
                                             placeholder="请选择">
                                             <el-option v-for="item in zidian" :key="item.diValue" :label="item.diName"
                                                :value="item.diValue">
                                             </el-option>
                                          </el-select>
                                          <el-input @blur="blur(formOneValue.entityField)"
                                             v-else-if="formOneValue.entityField == 'amount'"
                                             :disabled="formOneValue.isChange == 0"
                                             v-model.trim="sendDataInfo[formOneValue.entityField]"
                                             type="number"></el-input>
                                          <el-input v-else :disabled="formOneValue.isChange == 0"
                                             v-model.trim="sendDataInfo[formOneValue.entityField]"
                                             :maxlength="$store.state.inputLength"></el-input>
                                       </div>
                                    </template>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []"
                                    v-if="formOneValue.isShow == 1">
                                    <template>
                                       <!-- 系统字段 -->
                                       <div v-if="formOneValue.isReserved == 0">
                                          <span v-if="formOneValue.isRift == 1">
                                             <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                sendDataInfo[formOneValue.entityField] }}</a>
                                          </span>
                                          <span v-else-if="formOneValue.entityField == 'pscadSeccher'">{{
                                             sendDataInfo.pscadSeccherName }}</span>
                                          <span v-else-if="formOneValue.fieldType == 'date'">
                                             <span v-if="sendDataInfo[formOneValue.entityField]">
                                                {{
                                                   $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                }}
                                             </span>
                                          </span>
                                          <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                       </div>
                                    </template>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <div class="foot">
               <el-button @click="dataActionBox.showStatus = false">取 消</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                  v-if="dataActionBox.actionType == 0">保存</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                  v-if="dataActionBox.actionType == 1">保存</el-button>
            </div>
         </div>
      </el-drawer>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="sendDataInfo.smId" @TranData="changeInputModel"
            :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- <el-dialog :title="seTitle" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" top="1rem">
      <ExtractionPurPaymentApply :extractParamsData="extractParamsData" :id="553755277398017" ref="ExtractionPurPaymentApply" :parentData="parentData" :invoiceExtractData="parentSearchData1" @invoiceExtractMethods="getSelect" @sendTitle="getSearchName"  />
    </el-dialog> -->
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "toolStopRegistAction",
   props: [],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         selectDataTable: false,
         showTabs: "",
         dataActionBox: {
            showStatus: false,
            boxTitle: "新增信息" || "编辑信息",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            bgmId: "",
            rnmBatnumber: "",
            bgmName: "",
            rnmNumber: 0,
            rnmReason: "",
            rnmReserves1: "",
            rnmReserves2: "",
            rnmReserves3: "",
            rnmReserves4: "",
            rnmReserves5: "",
            rnmReserves6: "",
            registerTime: "",
            ssmState: "",
            ssmId: "",

         },
         formDataList: {},
         tabForm: [],
         mxForm: [],
         footForm: [],
         DialogVisible: false,
         seTitle: "",
         seWidth: "",
         zidian: [],
         parentSearchData: {},
         seId: "",
         setField: "",
         seType: "",
         ssmReasonFlag: false,//判断停售原因是否是手输 true：手输 false：选择
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      extendsClick() {
         this.seId = 8820873997127692
         this.seType = "extends"
         this.DialogVisible = true
         for (const key in this.sendDataInfo) {
            this.parentSearchData[key] = ""
         }
      },
      blur(type) {
         this.sendDataInfo[type] = this.$common.getDecimalInfo(1, this.sendDataInfo[type])
      },
      changeInputModel(val) {
         console.log(val, "停售");
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            if (this.seType == "bgmName" || this.seType == "extends") {
               for (const key in this.sendDataInfo) {
                  if (val[key] != undefined && val[key] != '' && val[key] != null) {
                     if (key == 'stReason') {
                        if (this.ssmReasonFlag) {
                           this.$set(this.sendDataInfo, key, val[key])
                        } else {
                           let arr = val[key].split(',')
                           this.$set(this.sendDataInfo, key, arr)
                        }
                     } else {
                        this.$set(this.sendDataInfo, key, val[key])
                     }
                  } else {
                     if (key == 'stReason') {
                        if (this.ssmReasonFlag) {
                           this.$set(this.sendDataInfo, key, "")
                        } else {
                           this.$set(this.sendDataInfo, key, [])
                        }
                     } else {
                        this.$set(this.sendDataInfo, key, "")
                     }
                  }
               }
            } else {
               this.paramValue(val)
            }
         }
      },
      // 赋值字段
      paramValue(val) {
         if (this.setField != null && this.setField != '' && this.setField != undefined) {
            let arr = this.setField.split(',')
            arr.forEach(item => {
               this.sendDataInfo[item] = val[item]
            })
         } else {
            this.sendDataInfo[this.seType] = val[this.seType]
         }
      },
      // 检索Id, 索引(表格中), 标识ppamId
      openSearch(sId, setField, type) {
         console.log(sId, setField, type);
         this.seId = sId;
         this.setField = setField
         this.seType = type;
         if (this.seType == 'lotno') {
            for (const key in this.sendDataInfo) {
               this.parentSearchData[key] = this.sendDataInfo[key]
            }
         } else if (this.seType == 'bgmName') {
            this.parentSearchData.bgiType = '工具'
            this.parentSearchData[this.seType] = this.sendDataInfo[this.seType]
         } else {
            console.log(this.sendDataInfo);
            this.parentSearchData[this.seType] = this.sendDataInfo[this.seType]
         }
         this.DialogVisible = true;

      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      initActionBox() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }

         this.sendDataInfo.registerTime = this.$moment().valueOf();
         this.dataActionBox.actionType = 0;
         this.dataActionBox.showStatus = false;
         if (!this.ssmReasonFlag) {
            this.sendDataInfo.stReason = []
         }
      },

      isShowData(name, value) {
         switch (name) {
            case "bgmId":
               var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.bgmId = dataInfo.bgmId;
                  this.sendDataInfo.bgmName = dataInfo.bgmName;
               }

               break;

            default:
               this.sendDataInfo[name] = value;
         }
         this.sendDataInfo[name] = value;
      },

      openBox(cate, formData, oldData = "") {
         this.formDataList = formData;
         this.showTabs = this.formDataList[0].jciName;
         this.filterMainField()
         if (cate == 0) {
            this.dataActionBox.boxTitle = "新增停售信息";
         } else {
            this.dataActionBox.boxTitle = "编辑停售信息";
            let dataInfo = JSON.parse(JSON.stringify(oldData));
            for (const key in this.sendDataInfo) {
               if (dataInfo[key] == undefined) {
                  this.$set(this.sendDataInfo, key, "")
               } else {
                  this.$set(this.sendDataInfo, key, dataInfo[key])
               }
            }
            if (!this.ssmReasonFlag) {
               let ssmre = this.sendDataInfo.stReason.split(',')
               this.$set(this.sendDataInfo, 'stReason', ssmre)
            }
            this.sendDataInfo.stockNum = dataInfo.stockNum + dataInfo.amount
         }
         this.dataActionBox.actionType = cate;
         this.dataActionBox.showStatus = true;
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].entityField == 'stReason') {
                  if (key.jurconfigform[index].fieldType == 'string') {
                     this.ssmReasonFlag = true
                  } else {
                     this.ssmReasonFlag = false
                  }
               }
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                  .jurconfigform[index])
            }
         })
         var arr = []
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "registerTime", this.$moment().valueOf())
         this.dataActionBox.actionType = 0;
         this.dataActionBox.showStatus = false;
      },
      sendDataAction(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               if (this.sendDataInfo.bgmId == "") {
                  this.$message({
                     message: "请选择商品",
                     type: "error",
                  });
                  return false;
               }
               this.sub()
            } else {
               return false;
            }
         });
      },
      async sub() {
         let data = JSON.parse(JSON.stringify(this.sendDataInfo))
         if (this.sendDataInfo.amount < 0) {
            return this.$message.error("停售数量不能小于零")
         }
         let stopReson = ''
         if (!this.ssmReasonFlag) {
            if (data.stReason.length > 0) {
               stopReson = data.stReason.join(',')
            }
         } else if (typeof data.stReason === 'string') {
            stopReson = data.stReason
         }
         data.stReason = stopReson
         let sendData = JSON.parse(JSON.stringify(data));
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.stopstoolStop(sendData);
         } else {
            var responseData = await this.$http.stopsupdateToolStop(sendData);
         }
         if (responseData.status == 200) {
            this.initActionBox();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            if (this.dataActionBox.actionType == 0) {
               this.$parent.setDataPageNumber(1);
            } else {
               this.$parent.getDataList();
            }
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      async getZiDian() {
         let res = await this.$http.getPartDictionariesData({ ids: [52] })
         console.log(res)
         this.zidian = res.result.tsyy
      }
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getZiDian()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-date-editor.el-input {
   width: 100%;
}
</style>